import app from './app';
import './core/index';
import './library/index';
import './components/index';

app.pageInit();
